import React, { useState, useEffect } from 'react';
import { View } from 'react-native';
import { ButtonComponent, JobSelectionModal ,SchoolStudentListModal ,SchoolFillDetails } from 'tutorapp-components';
import { apiService } from '../utils/apiRequest';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSchoolAppointment } from '../redux/actions/schoolAppointmentActions';
import { BLACK_COLOR } from '../utils/theme';
import { setSchoolAppointmentId, setSchoolJobValue, setSchoolSubjectId ,setSchoolSelectedStudent, setSchoolSessionType } from '../redux/actions/schoolPresetValuesActions';
import CircularProgress from '@mui/material/CircularProgress';

export default function SchoolFillDetailsScreen() {
  const [Visible, setVisible] = useState(false);
  const [originalStudentList, setOriginalStudentList] = useState([]); // Store original API response
  const [filteredStudentList, setFilteredStudentList] = useState([]); // Store filtered students
  const [joblist, setJoblist] = useState();
  const [subjectlist, setSubjectlist] = useState();
  const [selectedjob, setSelectedjob] = useState();
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [studentids, setstudentids] = useState('');
    const [loading , setloading]  = useState(false)
  

  const dispatch = useDispatch();
  const schoolJobValue = useSelector(state => state.schoolPresetValues.schoolJobValue);
  const selectedFranchise = useSelector((state) => state.franchise?.selectedFranchise);

  const navigate = useNavigate();

  const qwrqwdwq = {
    backarrow: './images/ic_back.svg',
    subjectIcon: './images/ic_subject.svg ',
    enrollmentIcon: './images/ic_enrollment.svg ',
    hoursIcon: './images/ic_remaining_hours.svg',
    studentIcon: './images/ic_student.svg',
    rightchevron: './images/ic_right.svg',
    sessionappointment: './images/ic_sessionappointment.svg',
    close: './images/ic_close.svg',
    progress: './images/ic_two.svg',
  };


  useEffect(() => {
    if (schoolJobValue && joblist?.length > 0 ) {
      const filteredjob  = joblist.find(
        (job) => job.id === schoolJobValue .id
      );
        setSelectedjob(filteredjob)
        handleConfirmjob(filteredjob)
  
    }
  }, [ joblist]);

  const getstudentlisting = async (selectedFranchise) => {
    try {
      
       setloading(true)
      const cancelappointment = process.env.REACT_APP_API_URL + 'getAllStudent';
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          franchise_id: selectedFranchise.franchise_id,
          tutor_id: selectedFranchise.tutor_id,
          appointment_type: 1,
        }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === 'success') {
        const mergedStudents = [
          ...Object.values(response.schools_student || {}),
          ...Object.values(response.families_student || {}),
        ];
        setOriginalStudentList(mergedStudents); // Store original list
        setFilteredStudentList(mergedStudents); // Initially, filtered list is the same as original
      } else {
        console.error('Failed to fetch students:', response.message);
      }
    } catch (error) {
      console.error('Error while fetching students:', error);
    }
    finally{

      setloading(false)
    }
  };

  const getjoblisting = async (selectedFranchise) => {
    try {
      setloading(true)
      const cancelappointment = process.env.REACT_APP_API_URL + 'getAllJob';
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          franchise_id: selectedFranchise.franchise_id,
          tutor_id: selectedFranchise.tutor_id,
          action: 'appointment',
        }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === 'success') {
        setJoblist(response.job);
      } else {
        console.error('Failed to fetch jobs:', response.message);
      }
    } catch (error) {
      console.error('Error while fetching jobs:', error);
    }
   
  };

  const getsubjectlisting = async (selectedFranchise, selectedjob) => {
    try {
      setloading(true)
      const cancelappointment = process.env.REACT_APP_API_URL + 'getAllSubject';
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          franchise_id: selectedFranchise.franchise_id,
          tutor_id: selectedFranchise.tutor_id,
          appointment_type: '1',
          job_id: `${selectedjob?.id}`,
        }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === 'success') {
        setSubjectlist(response.schools_subject);
      } else {
        console.error('Failed to fetch subjects:', response.message);
      }
    } catch (error) {
      console.error('Error while fetching subjects:', error);
    }
    finally{
      setloading(false)
    }
  };

  const handleConfirmjob = (selectedJob) => {
    setSelectedjob(selectedJob);
    // dispatch(setSessionType(selectedJob.session_type))
    dispatch(setSchoolSessionType(selectedJob.session_type))
    setVisible(false);
    getsubjectlisting(selectedFranchise, selectedJob);

    // Filter students based on selected job's name
    const filteredStudents = originalStudentList.filter((student) =>
      student.job_name?.toLowerCase() === selectedJob.name?.toLowerCase()
    );
    setFilteredStudentList(filteredStudents);
    setSelectedStudents([]); // Reset selected students
    setstudentids(''); // Reset student IDs
  };

  function getStudentIds(students) {
    return students.map((student) => student.id);
  }

  const [modalVisible, setModalVisible] = useState(false);

  const onarrowclick = () => {
    navigate('/editAppointment');
  };

  const ondelete = () => {
    console.log('deleteclick');
  };

  const handlejob = () => {
    setVisible(true);
  };


  const handlecontinue = () => {
    const schoolformatedata = {
      tutor_id: selectedFranchise.tutor_id,
      franchise_id: selectedFranchise.franchise_id,
      student_id: studentids,
      job_id: selectedjob.id,
      subject_id: subjectlist[0]?.id,
      tutor_address: selectedStudents[0]?.tutor_address,
    };

    dispatch(createSchoolAppointment(schoolformatedata));
    dispatch(setSchoolJobValue(selectedjob))
    dispatch(setSchoolAppointmentId(studentids))
    dispatch(setSchoolSubjectId(subjectlist))
    dispatch(setSchoolSelectedStudent(selectedStudents))
    navigate('/schooldatetime');
  };

  const handlestudent = () => {
    setModalVisible(true);
  };

  const handleConfirm = (selectedIds) => {
    setSelectedStudents(selectedIds);
    const studentIds = getStudentIds(selectedIds);
    setstudentids(studentIds);
    setModalVisible(false);
  };

  const handleback = () => {
    navigate('/SelectAppointmentType');
  };

  const isContinueDisabled =
  !selectedStudents ||
  selectedStudents.length === 0 ||
  !selectedjob ||
  !subjectlist ||
  subjectlist.length === 0 ||
  (selectedjob.total_hours !== "N/A" && 
   (selectedjob.remaining_hours === 0 || selectedjob.remaining_hours < 0));

  const handleselectionclose = () => {
    navigate('/MyAppointment');
  };

  useEffect(() => {
    getstudentlisting(selectedFranchise);
    getjoblisting(selectedFranchise);
  }, [selectedFranchise]);


  return (
    <div>
     {loading && (
                 <div
                   style={{
                     position: 'fixed',
                     top: 0,
                     left: 0,
                     width: '100%',
                     height: '100%',
                     background: 'rgba(0, 0, 0, 0.5)',
                     display: 'flex',
                     justifyContent: 'center',
                     alignItems: 'center',
                     zIndex: 1000,
                   }}
                 >
                   <CircularProgress
                     size={40}
                     sx={{ color: 'black' }}
                     aria-label="Loading"
                   />
                 </div>
               )}

      <SchoolFillDetails
        selectedStudents={selectedStudents}
        handleEditGeneral={onarrowclick}
        ondelete={ondelete}
        handlejob={handlejob}
        handlestudent={handlestudent}
        selectedjob={selectedjob}
        selectedsubject={subjectlist}
        icons={qwrqwdwq}
        handleselectionclose={handleselectionclose}
      />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ width: '300px', marginBottom: 10 }}>
          <ButtonComponent
            onPress={isContinueDisabled ? null : handlecontinue}
            label="Continue"
            disabled={isContinueDisabled}
            style={{
              backgroundColor: isContinueDisabled ? '#ccc' : BLACK_COLOR,
              paddingVertical: 12,
              fontFamily: 'GT-Walsheim',
              pointerEvents: isContinueDisabled ? 'none' : 'auto',
            }}
            textStyle={{
              color: isContinueDisabled ? '#666' : '#fff',
              fontFamily: 'GT-Walsheim',
            }}
          />
        </div>

        <div style={{ width: '300px' }}>
          <ButtonComponent
            onPress={handleback}
            label="Back"
            style={{ backgroundColor: '#E9EDF1', paddingVertical: 12, fontFamily: 'GT-Walsheim' }}
            textStyle={{ color: '#000', fontFamily: 'GT-Walsheim' }}
          />
        </div>
      </div>

      <SchoolStudentListModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        students={filteredStudentList} // Pass filtered students
        selectedStudents={selectedStudents}
        onConfirm={handleConfirm}
        icons={{
          close: './images/ic_close2.svg',
        }}
      />

      <View>
        <JobSelectionModal
          visible={Visible}
          onClose={() => setVisible(false)}
          data={joblist}
          onConfirm={handleConfirmjob}
          iconPaths={{
            date: './images/Calendar.svg',
            students: './images/User.svg',
            search: './images/Search.svg',
            close: './images/ic_close2.svg',
          }}
        />
      </View>
    </div>
  );
}